import { Checkbox } from 'antd';
import React, { useState } from 'react'

function MappedDevicesTable({ data }) {
    const [selectedRowKey, setSelectedRowKey] = useState(null);
    return (
        <>
            <div>
                <div className={`min-w-full ${data ? 'w-max' : 'w-full'} rounded-lg flex justify-center`}>
                    <table className="w-full overflow-scroll relative">
                        <thead className="border rounded-lg">
                            <tr>
                                <th>Code</th>
                                <th>Device</th>
                                <th>Brand</th>
                                <th>Model</th>
                                <th>Description</th>
                            </tr>
                            {/* <tr className="bg-[#DEF3F2]">
                                <td className="py-0.5" colSpan={12}></td>
                            </tr> */}
                        </thead>
                        <tbody className="text-center">
                            {
                                     data?.map((item, idx) => (
                                        <React.Fragment key={item.key || idx}>
                                            <tr className='border-b'>
                                                <td>{item.deviceCode}</td>
                                                <td>{item.deviceName}</td>
                                                <td>{item.deviceBrand}</td>
                                                <td>{item.deviceModel}</td>
                                                <td>{item.connectivity}</td>
                                            </tr>
                                            {/* <tr className="bg-[#DEF3F2]">
                                                <td className="py-0.5" colSpan={12}></td>
                                            </tr> */}
                                        </React.Fragment>
                                    ))
                           
                            }

                        </tbody>
                    </table>
                </div >
            </div >
        </>
    )
}

export default MappedDevicesTable;